import { getAuth } from "firebase/auth";
import { FirebaseAuthRepository } from "../../core/repositories/auth/FirebaseAuthRepository";
import IAuthRepository from "../../core/repositories/auth/IAuthRepository";
import Cubit from "../../core/utils/cubit";
import { app } from "../../core/utils/firebase";
import { IProcessingService, ProcessingService } from "../processing-service/ProcessingService";
import { AuthState } from "./authStates";

abstract class IAuthCubit extends Cubit<AuthState> {
    public abstract login: () => Promise<AuthState>;
    public abstract logout: () => Promise<AuthState>;
}

class AuthCubit extends IAuthCubit {

    private static instance: IAuthCubit;
    private authRepository: IAuthRepository = new FirebaseAuthRepository();
    private processingService: IProcessingService = ProcessingService.getInstance();

    private constructor() {
        super({ state: 'LOADING' });
        // specific only for firebase use case
        const auth = getAuth(app);
        auth.onAuthStateChanged((user) => {
            this.authRepository.getCurrentUser().then((user) => {
                if (user !== undefined) {
                    this.emit({ state: 'LOGGEDIN', user });
                } else {
                    this.emit({ state: 'LOGGEDOUT' });
                }
            });
        });
    }

    public static getInstance(): IAuthCubit {
        if (this.instance === undefined) {
            this.instance = new AuthCubit();
        }
        return this.instance;
    }

    public login: () => Promise<AuthState> = async () => {
        this.emit({ state: 'LOADING' });
        this.processingService.startProcessing();
        const user = await this.authRepository.login();
        if (user !== undefined) {
            this.emit({ state: 'LOGGEDIN', user: user });
        } else {
            this.emit({ state: 'LOGGEDOUT' });
        }
        this.processingService.stopProcessing();
        return this.state;
    }
    public logout: () => Promise<AuthState> = async () => {
        this.emit({ state: 'LOADING' });
        this.processingService.startProcessing();
        try {
            await this.authRepository.logout();
        } catch (error) {
            this.emit({ state: 'ERROR' });
        }
        this.emit({ state: 'LOGGEDOUT' });
        this.processingService.stopProcessing();
        return this.state;
    }

}

export { AuthCubit, IAuthCubit };
